import { ReactNode } from 'react'

import { TransProps } from 'react-i18next'

export enum NotificationType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  INFO_MOBILE = 'info_mobile',
  SUCCESS = 'success',
  SUCCESS_MOBILE = 'success_mobile',
}

export interface SessionNotificationMessage {
  code: string,
  values?: Record<string, string>
}

export interface SessionNotificationConfig {
  type: NotificationType,
  message: SessionNotificationMessage,
  dismiss?: boolean,
  style?: string,
  duration?: number | 'Infinity' // remix session uses JSON.stringify which converts Infinity to null, so we need to use a string,
}

export interface NotificationConfig {
  type: NotificationType,
  message: string | TransProps<string> | ReactNode,
  dismiss?: boolean,
  style?: string,
  detailedMessage?: string,
  duration?: number | 'Infinity', // remix session uses JSON.stringify which converts Infinity to null, so we need to use a string
  id?: string,
}